import { Box, Button, CircularProgress, FormControl, IconButton, Modal, TextField, Typography } from '@mui/material';
import styles from './MoveOfficeModal.module.css';
import CloseIcon from '@mui/icons-material/Close';
import OfficeTreeView from '../OfficeTreeView';
import { useState } from 'react';
import { GetOffice_Out, OfficeState, OfficesService } from 'src/pehra-ts-client';
import { useMutation, useQueryClient } from '@tanstack/react-query';

export interface IMoveOfficeModal {
  openModal: boolean;
  handleCloseModal: () => void;
  currentOfficeDetail: GetOffice_Out | null;
}

type TFormData = {
  parent_office_id: string | null;
  office_name: string;
};

const MoveOfficeModal: React.FC<IMoveOfficeModal> = ({ openModal, handleCloseModal, currentOfficeDetail }) => {
  const [selectedOffice, setSelectedOffice] = useState<any>(null);

  const queryClient = useQueryClient();

  const moveOffice = async () => {
    try {
      const res = await OfficesService.updateOffice(currentOfficeDetail?.id as string, {
        office_name: currentOfficeDetail?.office_name as string,
        state: currentOfficeDetail?.state as OfficeState,
        parent_office_id: selectedOffice?.id
      });
      return res;
    } catch (error) {
      throw error;
    }
  };

  const moveOfficeMutation = useMutation({
    mutationFn: moveOffice,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['officesList', currentOfficeDetail?.id || null]
      });
      queryClient.invalidateQueries({
        queryKey: ['officeTree']
      });
      handleCloseModal();
    }
  });

  const handleMoveOffice = () => {
    moveOfficeMutation.mutate();
  };

  const modalContent = (
    <Box
      sx={{
        padding: '20px'
      }}
    >
      <OfficeTreeView setSelectedOffice={setSelectedOffice} />
      <Box>{moveOfficeMutation.isPending && <CircularProgress />}</Box>
      <Box
        sx={{
          marginTop: '50px',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center'
        }}
      >
        <Button
          variant="outlined"
          color="error"
          style={{ margin: '20px' }}
          onClick={() => {
            handleCloseModal();
          }}
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          color="primary"
          style={{ margin: '20px' }}
          onClick={() => {
            handleMoveOffice();
          }}
        >
          Move to {selectedOffice?.name}
        </Button>
      </Box>
    </Box>
  );

  return (
    <Modal open={openModal} onClose={handleCloseModal}>
      <Box className={styles.modalContainer}>
        <IconButton onClick={handleCloseModal} style={{ position: 'absolute', right: '10px', top: '10px' }}>
          <CloseIcon />
        </IconButton>
        <Box>
          <Typography variant="h3" style={{ padding: '20px' }}>
            Office {currentOfficeDetail ? `${currentOfficeDetail.office_name}` : ''}
          </Typography>
          <Typography variant="h4" style={{ padding: '20px' }}>
            Select New Office Location
          </Typography>
        </Box>
        {modalContent}
      </Box>
    </Modal>
  );
};

export default MoveOfficeModal;
